import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "TypeScript's biggest flaw and how you can use ducks to fix it",
  "description": "",
  "published": "2019-06-17T00:00:00.000Z",
  "redirect_from": ["/blog/typescripts-biggest-flaw-and-how-you-can-use-ducks-to-fix-it/swizec/9122"],
  "categories": "Computer Science, Front End, Technical",
  "hero": "./img/3It1RzR.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`TypeScript is wonderful. Been using it more and more and I love it. 🥰`}</p>
    <p>{`There's something magical about useful autocomplete suggestions, object blobs with property hints, and auto imports. That's right, auto imports.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/8bd112fcc6951c3aa3a9850ec9ab879f/6b26f/3It1RzR.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "12.556053811659194%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'50\\'%20viewBox=\\'0%200%20400%2050\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M73%2015l1%203-15%201H43l-1%201a846%20846%200%200044-1c-5%200-8-1-5-3h2c2%202%204%201%204-1%200-3-3-4-4-2h-1l-2-1c-2%200-2%200-2%204%201%202%200%203-1%203l-2-1%201-3v-2h-2c-1-1-1%200-1%202\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/8bd112fcc6951c3aa3a9850ec9ab879f/ca0a1/3It1RzR.webp 223w", "/static/8bd112fcc6951c3aa3a9850ec9ab879f/75680/3It1RzR.webp 445w", "/static/8bd112fcc6951c3aa3a9850ec9ab879f/8d1ba/3It1RzR.webp 890w", "/static/8bd112fcc6951c3aa3a9850ec9ab879f/3838e/3It1RzR.webp 1335w", "/static/8bd112fcc6951c3aa3a9850ec9ab879f/237a5/3It1RzR.webp 1658w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/8bd112fcc6951c3aa3a9850ec9ab879f/e92b6/3It1RzR.png 223w", "/static/8bd112fcc6951c3aa3a9850ec9ab879f/e66bf/3It1RzR.png 445w", "/static/8bd112fcc6951c3aa3a9850ec9ab879f/4ef49/3It1RzR.png 890w", "/static/8bd112fcc6951c3aa3a9850ec9ab879f/4e814/3It1RzR.png 1335w", "/static/8bd112fcc6951c3aa3a9850ec9ab879f/6b26f/3It1RzR.png 1658w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/8bd112fcc6951c3aa3a9850ec9ab879f/4ef49/3It1RzR.png",
              "alt": "3It1RzR",
              "title": "3It1RzR",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Press enter and VSCode adds `}<inlineCode parentName="p">{`import { FieldTypes } from './types'`}</inlineCode>{` at the top.`}</p>
    <p>{`And check this out: I got a form builder that takes JavaScript blobs as configuration. VSCode is smart enough to tell me when they're wrong. 👌`}</p>
    <p>{`This works:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/962529e01fdae7566facc6e19f714455/6b95e/8jAnn0L.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "29.14798206278027%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'117\\'%20viewBox=\\'0%200%20400%20117\\'%20preserveAspectRatio=\\'none\\'/%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/962529e01fdae7566facc6e19f714455/ca0a1/8jAnn0L.webp 223w", "/static/962529e01fdae7566facc6e19f714455/75680/8jAnn0L.webp 445w", "/static/962529e01fdae7566facc6e19f714455/8d1ba/8jAnn0L.webp 890w", "/static/962529e01fdae7566facc6e19f714455/3838e/8jAnn0L.webp 1335w", "/static/962529e01fdae7566facc6e19f714455/bb4a2/8jAnn0L.webp 1458w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/962529e01fdae7566facc6e19f714455/e92b6/8jAnn0L.png 223w", "/static/962529e01fdae7566facc6e19f714455/e66bf/8jAnn0L.png 445w", "/static/962529e01fdae7566facc6e19f714455/4ef49/8jAnn0L.png 890w", "/static/962529e01fdae7566facc6e19f714455/4e814/8jAnn0L.png 1335w", "/static/962529e01fdae7566facc6e19f714455/6b95e/8jAnn0L.png 1458w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/962529e01fdae7566facc6e19f714455/4ef49/8jAnn0L.png",
              "alt": "8jAnn0L",
              "title": "8jAnn0L",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Got a field with a `}<inlineCode parentName="p">{`name`}</inlineCode>{` and a `}<inlineCode parentName="p">{`placeholder`}</inlineCode>{`. Remove one and o-oh.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/b6980e13be7404fcf8db9fa612ffa952/e8950/ulnjYvE.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "35.42600896860987%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'142\\'%20viewBox=\\'0%200%20400%20142\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M64%20103v5h24v-9H64v4\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/b6980e13be7404fcf8db9fa612ffa952/ca0a1/ulnjYvE.webp 223w", "/static/b6980e13be7404fcf8db9fa612ffa952/75680/ulnjYvE.webp 445w", "/static/b6980e13be7404fcf8db9fa612ffa952/8d1ba/ulnjYvE.webp 890w", "/static/b6980e13be7404fcf8db9fa612ffa952/3838e/ulnjYvE.webp 1335w", "/static/b6980e13be7404fcf8db9fa612ffa952/e11e5/ulnjYvE.webp 1780w", "/static/b6980e13be7404fcf8db9fa612ffa952/b84eb/ulnjYvE.webp 2000w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/b6980e13be7404fcf8db9fa612ffa952/e92b6/ulnjYvE.png 223w", "/static/b6980e13be7404fcf8db9fa612ffa952/e66bf/ulnjYvE.png 445w", "/static/b6980e13be7404fcf8db9fa612ffa952/4ef49/ulnjYvE.png 890w", "/static/b6980e13be7404fcf8db9fa612ffa952/4e814/ulnjYvE.png 1335w", "/static/b6980e13be7404fcf8db9fa612ffa952/701e9/ulnjYvE.png 1780w", "/static/b6980e13be7404fcf8db9fa612ffa952/e8950/ulnjYvE.png 2000w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/b6980e13be7404fcf8db9fa612ffa952/4ef49/ulnjYvE.png",
              "alt": "ulnjYvE",
              "title": "ulnjYvE",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`The error is cryptic type vomit. You get used to that. Means that one of your blobs doesn't match any known field type.`}</p>
    <p>{`But get this, add `}<inlineCode parentName="p">{`type: "email"`}</inlineCode>{` and no need for a placeholder 😮`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/e18cfd3b2cd123af7500025f50fbc7ec/4a00e/43vXqhT.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "37.668161434977584%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'151\\'%20viewBox=\\'0%200%20400%20151\\'%20preserveAspectRatio=\\'none\\'/%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/e18cfd3b2cd123af7500025f50fbc7ec/ca0a1/43vXqhT.webp 223w", "/static/e18cfd3b2cd123af7500025f50fbc7ec/75680/43vXqhT.webp 445w", "/static/e18cfd3b2cd123af7500025f50fbc7ec/8d1ba/43vXqhT.webp 890w", "/static/e18cfd3b2cd123af7500025f50fbc7ec/3838e/43vXqhT.webp 1335w", "/static/e18cfd3b2cd123af7500025f50fbc7ec/05352/43vXqhT.webp 1406w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/e18cfd3b2cd123af7500025f50fbc7ec/e92b6/43vXqhT.png 223w", "/static/e18cfd3b2cd123af7500025f50fbc7ec/e66bf/43vXqhT.png 445w", "/static/e18cfd3b2cd123af7500025f50fbc7ec/4ef49/43vXqhT.png 890w", "/static/e18cfd3b2cd123af7500025f50fbc7ec/4e814/43vXqhT.png 1335w", "/static/e18cfd3b2cd123af7500025f50fbc7ec/4a00e/43vXqhT.png 1406w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/e18cfd3b2cd123af7500025f50fbc7ec/4ef49/43vXqhT.png",
              "alt": "43vXqhT",
              "title": "43vXqhT",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Whoa`}</p>
    <p><img parentName="p" {...{
        "src": "/38eef0fb5df34ae693a423bbc3525ed1/media-DyvyiFFXF1Yli-giphy.gif",
        "alt": "whoa giphy"
      }}></img></p>
    <p>{`So what's going on here? What's TypeScript doing to support this? And why do we need a `}<inlineCode parentName="p">{`type`}</inlineCode>{` property if we're using a typed language?`}</p>
    <h2 {...{
      "id": "static-analysis"
    }}>{`Static analysis`}</h2>
    <p><a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Static_program_analysis"
      }}>{`Static analysis`}</a>{` is where TypeScript shines. Its main design goal 👉 enable static analysis of JavaScript`}</p>
    <blockquote>
      <p parentName="blockquote">{`Static program analysis is the analysis of computer software that is performed without actually executing programs, in contrast with dynamic analysis, which is analysis performed on programs while they are executing.`}</p>
    </blockquote>
    <p>{`Static analysis uses `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Type_system#Static_typing"
      }}>{`static types`}</a>{` to understand your code. Editors use this understanding to help you write better code.`}</p>
    <p>{`Everything from autocompletion, hints on object properties, and squiggly lines when you get something wrong. Some editors even integrate with documentation and give you help right in the editor.`}</p>
    <p>{`TypeScript with VSCode brings all that to JavaScript.`}</p>
    <p>{`You get a better coding experience most of the time. Sometimes you fight the type system, but it's got your back ... mostly. Great for large teams and large codebases.`}</p>
    <p>{`Know your code has at least a remote chance of being correct without running every single line? Love it ❤️`}</p>
    <h2 {...{
      "id": "dynamic-analysis"
    }}>{`Dynamic analysis`}</h2>
    <p>{`In contrast to static analysis you have `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Dynamic_program_analysis"
      }}>{`dynamic analysis`}</a>{`. That's JavaScript's normal mode.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Dynamic program analysis is the analysis of computer software that is performed by executing programs on a real or virtual processor. For dynamic program analysis to be effective, the target program must be executed with sufficient test inputs to produce interesting behavior.`}</p>
    </blockquote>
    <p>{`To analyze a dynamic language, you gotta run it. That's where test driven development comes in.`}</p>
    <p>{`You don't have a static type system saving your butt for some classes of errors. You gotta run the thing and see if it works. And you better make sure you run every line of code.`}</p>
    <p>{`If you don't, I promise your users will 😉`}</p>
    <h2 {...{
      "id": "duck-typing"
    }}>{`Duck typing`}</h2>
    <p><img parentName="p" {...{
        "src": "/0b2b45f1da0416b68235408d7ca0d4fe/media-krewXUB6LBja-giphy.gif",
        "alt": "duck giphy"
      }}></img></p>
    <p><a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Duck_typing"
      }}>{`Duck typing`}</a>{` is a strange beast most popular in the land of Lisp. It falls under dynamic typing, but statically typed duck languages exist also. Wikipedia classifies it as the 4th major category next to static, dynamic, and nominal typing.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If it walks like a duck and it quacks like a duck, then it must be a duck`}</p>
    </blockquote>
    <p>{`The duck test 🦆`}</p>
    <p>{`You're duck typing every time you write code like `}<inlineCode parentName="p">{`if (object.property && object.property.value === 'something')`}</inlineCode></p>
    <p>{`Verify the object is a duck, has a `}<inlineCode parentName="p">{`property`}</inlineCode>{`, then use it like a duck.`}</p>
    <h2 {...{
      "id": "type-guards-in-typescript"
    }}>{`Type guards in TypeScript`}</h2>
    <p>{`That brings us to TypeScript's biggest flaw.`}</p>
    <p>{`From `}<a parentName="p" {...{
        "href": "https://github.com/Microsoft/TypeScript/wiki/TypeScript-Design-Goals"
      }}>{`TypeScript Design Goals`}</a></p>
    <blockquote>
      <p parentName="blockquote">{`Impose `}<strong parentName="p">{`no runtime`}</strong>{` overhead on emitted programs. Emit clean, idiomatic, recognizable JavaScript code.`}</p>
    </blockquote>
    <p>{`TypeScript is a static analysis tool only. No types at runtime. No type checking. No validations. Nothing.`}</p>
    <p>{`Great for program size and understandability. Not great for useful type system.`}</p>
    <p>{`Say you've got a form builder with two field types like I mentioned before.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=typescript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20A%20union%20type%20for%20field%20types%0Aexport%20type%20FieldTypes%20%3D%20TextFieldProps%20%7C%20EmailFieldProps%3B%0A%0A%2F%2F%20All%20fields%20share%20some%20properties%0Aexport%20interface%20CoreFieldProps%20%7B%0A%20%20%20%20name%3A%20string%3B%0A%20%20%20%20initialValue%3F%3A%20string%3B%0A%7D%0A%0A%2F%2F%20Text%20fields%20require%20a%20placeholder%0A%2F%2F%20type%20is%20%60text%60%20by%20default%0Aexport%20interface%20TextFieldProps%20extends%20CoreFieldProps%20%7B%0A%20%20%20%20type%3F%3A%20%22text%22%3B%0A%20%20%20%20placeholder%3A%20string%3B%0A%7D%0A%0A%2F%2F%20Email%20fields%20don't%20require%20a%20placeholder%0Aexport%20interface%20EmailFieldProps%20extends%20CoreFieldProps%20%7B%0A%20%20%20%20type%3A%20%22email%22%3B%0A%20%20%20%20placeholder%3F%3A%20string%3B%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "566px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "96.8609865470852%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'387\\'%20viewBox=\\'0%200%20400%20387\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M24%2035c-2%201-2%20315%200%20317%202%203%20350%203%20352%200%202-2%202-316%200-317H24\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/878e3ff48792048db79f0f0dff6a384b/ca0a1/techletter.app-screenshot-1560790608889.webp 223w", "/static/878e3ff48792048db79f0f0dff6a384b/75680/techletter.app-screenshot-1560790608889.webp 445w", "/static/878e3ff48792048db79f0f0dff6a384b/3161c/techletter.app-screenshot-1560790608889.webp 566w"],
                "sizes": "(max-width: 566px) 100vw, 566px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/878e3ff48792048db79f0f0dff6a384b/e92b6/techletter.app-screenshot-1560790608889.png 223w", "/static/878e3ff48792048db79f0f0dff6a384b/e66bf/techletter.app-screenshot-1560790608889.png 445w", "/static/878e3ff48792048db79f0f0dff6a384b/6fe44/techletter.app-screenshot-1560790608889.png 566w"],
                "sizes": "(max-width: 566px) 100vw, 566px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/878e3ff48792048db79f0f0dff6a384b/6fe44/techletter.app-screenshot-1560790608889.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`A union `}<inlineCode parentName="p">{`FieldTypes`}</inlineCode>{` type saves typing in a bunch of places.`}</p>
    <p>{`Then we got a `}<inlineCode parentName="p">{`CoreFieldProps`}</inlineCode>{` interface that defines properties all fields share. Every field needs a `}<inlineCode parentName="p">{`name`}</inlineCode>{`, optionally an `}<inlineCode parentName="p">{`initialValue`}</inlineCode>{` too.`}</p>
    <p>{`Specific field types extend the core props and add their own. Most importantly they add the `}<inlineCode parentName="p">{`type`}</inlineCode>{` field.`}</p>
    <p>{`That's how TypeScript knows what you mean when you write`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=typescript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%3CForm%0A%20%20%20%20onSubmit%3D%7Bvalues%20%3D%3E%20alert(JSON.stringify(values%2C%20null%2C%202))%7D%0A%20%20%20%20fields%3D%7B%5B%0A%20%20%20%20%20%20%20%20%7B%20name%3A%20%22firstName%22%2C%20placeholder%3A%20%22First%20Name%22%20%7D%2C%0A%20%20%20%20%20%20%20%20%7B%20name%3A%20%22lastName%22%2C%20placeholder%3A%20%22Last%20Name%22%20%7D%2C%0A%20%20%20%20%20%20%20%20%7B%20name%3A%20%22email%22%2C%20type%3A%20%22email%22%20%7D%0A%20%20%20%20%5D%7D%20%2F%3E"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "606px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "48.87892376681614%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'195\\'%20viewBox=\\'0%200%20400%20195\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M22%2033c-2%202-2%20128%200%20130s354%202%20356%200%202-128%200-130-354-2-356%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/705d443a004539fc60c2b834ebeaecda/ca0a1/techletter.app-screenshot-1560790608727.webp 223w", "/static/705d443a004539fc60c2b834ebeaecda/75680/techletter.app-screenshot-1560790608727.webp 445w", "/static/705d443a004539fc60c2b834ebeaecda/18e7e/techletter.app-screenshot-1560790608727.webp 606w"],
                "sizes": "(max-width: 606px) 100vw, 606px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/705d443a004539fc60c2b834ebeaecda/e92b6/techletter.app-screenshot-1560790608727.png 223w", "/static/705d443a004539fc60c2b834ebeaecda/e66bf/techletter.app-screenshot-1560790608727.png 445w", "/static/705d443a004539fc60c2b834ebeaecda/4d4a2/techletter.app-screenshot-1560790608727.png 606w"],
                "sizes": "(max-width: 606px) 100vw, 606px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/705d443a004539fc60c2b834ebeaecda/4d4a2/techletter.app-screenshot-1560790608727.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Looks at the first two blobs, sees they match `}<inlineCode parentName="p">{`TextFieldProps`}</inlineCode>{`. They've got a name and a placeholder, no type.`}</p>
    <p>{`The last blob uses `}<inlineCode parentName="p">{`type: "email"`}</inlineCode>{` so TypeScript knows it's okay that there's no placeholder. Optional in emails.`}</p>
    <h2 {...{
      "id": "duck-typing-at-runtime"
    }}>{`Duck typing at runtime`}</h2>
    <p>{`Static analysis worked great in the editor. What about when you want to render different fields based on their type?`}</p>
    <p>{`You're using a typed language right, how hard can it be.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=typescript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20RenderField%20%3D%20(props%3A%20FieldTypes)%20%3D%3E%20%7B%0A%09if%20(typeof%20props%20%3D%3D%20TextFieldProps)%20%7B%0A%09%09%2F%2F%20render%20a%20text%20field%0A%09%7Delse%20if%20(typeof%20props%20%3D%3D%20EmailFieldProps)%20%7B%0A%09%09%2F%2F%20render%20an%20email%20field%0A%09%7D%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "486px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "60.53811659192825%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'243\\'%20viewBox=\\'0%200%20400%20243\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M27%2042c-2%203-1%20158%200%20161%203%203%20343%203%20346%200%201-3%202-158%200-161S29%2039%2027%2042\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/617816e313d2eee0092468c794f22a81/ca0a1/techletter.app-screenshot-1560797141465.webp 223w", "/static/617816e313d2eee0092468c794f22a81/75680/techletter.app-screenshot-1560797141465.webp 445w", "/static/617816e313d2eee0092468c794f22a81/aba12/techletter.app-screenshot-1560797141465.webp 486w"],
                "sizes": "(max-width: 486px) 100vw, 486px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/617816e313d2eee0092468c794f22a81/e92b6/techletter.app-screenshot-1560797141465.png 223w", "/static/617816e313d2eee0092468c794f22a81/e66bf/techletter.app-screenshot-1560797141465.png 445w", "/static/617816e313d2eee0092468c794f22a81/4ee7f/techletter.app-screenshot-1560797141465.png 486w"],
                "sizes": "(max-width: 486px) 100vw, 486px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/617816e313d2eee0092468c794f22a81/4ee7f/techletter.app-screenshot-1560797141465.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Not so fast buster.`}</p>
    <p>{`JavaScript has no idea about your types. `}<inlineCode parentName="p">{`typeof props`}</inlineCode>{` evaluates to `}<inlineCode parentName="p">{`object`}</inlineCode>{`. That's not gonna match your artisanally crafted types you worked so hard to build 😉`}</p>
    <p>{`Instead, you'll have to use `}<a parentName="p" {...{
        "href": "https://www.typescriptlang.org/docs/handbook/advanced-types.html#type-guards-and-differentiating-types"
      }}>{`TypeScript Type Guards`}</a></p>
    <p>{`Two types of guards prove useful in the wild:`}</p>
    <ol>
      <li parentName="ol">{`Duck typing`}</li>
      <li parentName="ol">{`Explicit `}<inlineCode parentName="li">{`type`}</inlineCode>{` property`}</li>
    </ol>
    <h3 {...{
      "id": "duck-typing-1"
    }}>{`Duck typing`}</h3>
    <p>{`A duck typed type guard uses the duck test. If property exists on object, do the things.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=typescript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=function%20isDuck(animal%3A%20Duck%20%7C%20Elephant%20%7C%20Donkey)%20%7B%0A%09return%20%22swim%22%20in%20animal%20%26%26%20%22fly%22%20in%20animal%3B%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "510px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "43.946188340807176%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'175\\'%20viewBox=\\'0%200%20400%20175\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M26%2039c-2%202-1%2096%201%2098s344%202%20346%200%203-96%201-98-346-2-348%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/cb2cfb9b38c766241113377d8088535f/ca0a1/techletter.app-screenshot-1560797140706.webp 223w", "/static/cb2cfb9b38c766241113377d8088535f/75680/techletter.app-screenshot-1560797140706.webp 445w", "/static/cb2cfb9b38c766241113377d8088535f/b7235/techletter.app-screenshot-1560797140706.webp 510w"],
                "sizes": "(max-width: 510px) 100vw, 510px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/cb2cfb9b38c766241113377d8088535f/e92b6/techletter.app-screenshot-1560797140706.png 223w", "/static/cb2cfb9b38c766241113377d8088535f/e66bf/techletter.app-screenshot-1560797140706.png 445w", "/static/cb2cfb9b38c766241113377d8088535f/0abdd/techletter.app-screenshot-1560797140706.png 510w"],
                "sizes": "(max-width: 510px) 100vw, 510px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/cb2cfb9b38c766241113377d8088535f/0abdd/techletter.app-screenshot-1560797140706.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`An animal is a duck if it can both swim and fly. The `}<inlineCode parentName="p">{`in`}</inlineCode>{` operator checks for the existence of a key (or property) on an object.`}</p>
    <h3 {...{
      "id": "explicit-type-property"
    }}>{`Explicit type property`}</h3>
    <p>{`The other approach works best in an object blob situation. You provide a `}<inlineCode parentName="p">{`type`}</inlineCode>{` attribute, define types with hardcoded values, then make sure they're defined.`}</p>
    <p>{`Use those values at runtime to decide what to do`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=typescript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20RenderField%20%3D%20(props%3A%20FieldTypes)%20%3D%3E%20%7B%0A%20%20%20%20switch%20(props.type)%20%7B%0A%20%20%20%20%20%20%20%20case%20%22email%22%3A%0A%20%20%20%20%20%20%20%20%20%20%20%20%2F%2F%20render%20email%20field%0A%20%20%20%20%20%20%20%20case%20%22text%22%3A%0A%20%20%20%20%20%20%20%20%20%20%20%20%2F%2F%20render%20text%20field%0A%20%20%20%20%7D%0A%7D%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "454px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "69.05829596412556%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'276\\'%20viewBox=\\'0%200%20400%20276\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M30%2044l-2%201v187l2%201c4%203%20336%203%20340%200l2-1V45l-2-1c-4-3-336-3-340%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2fd8507b278d1c25585af0ff68b9f5c2/ca0a1/techletter.app-screenshot-1560797142337.webp 223w", "/static/2fd8507b278d1c25585af0ff68b9f5c2/75680/techletter.app-screenshot-1560797142337.webp 445w", "/static/2fd8507b278d1c25585af0ff68b9f5c2/44d9f/techletter.app-screenshot-1560797142337.webp 454w"],
                "sizes": "(max-width: 454px) 100vw, 454px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2fd8507b278d1c25585af0ff68b9f5c2/e92b6/techletter.app-screenshot-1560797142337.png 223w", "/static/2fd8507b278d1c25585af0ff68b9f5c2/e66bf/techletter.app-screenshot-1560797142337.png 445w", "/static/2fd8507b278d1c25585af0ff68b9f5c2/b3c1d/techletter.app-screenshot-1560797142337.png 454w"],
                "sizes": "(max-width: 454px) 100vw, 454px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/2fd8507b278d1c25585af0ff68b9f5c2/b3c1d/techletter.app-screenshot-1560797142337.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`An object constructor can help too. `}<inlineCode parentName="p">{`new EmailFieldProps()`}</inlineCode>{` and it sets `}<inlineCode parentName="p">{`this.type`}</inlineCode>{` to email by default.`}</p>
    <p>{`But I prefer blobs for passing data and use duck typing when dealing with actual objects. If it can do what I need, what do I care what type it is?`}</p>
    <h1 {...{
      "id": "quack"
    }}>{`Quack`}</h1>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "520px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/a0b32722ec3cedde7299e09507965df0/69902/kr3gtct.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "66.81614349775785%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'267\\'%20viewBox=\\'0%200%20400%20267\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M209%2065c-11%208-6%2024%205%2017%204-2%207-9%207-13-2-6-8-8-12-4m83%203c-1%203-1%206%201%2011%203%207%208%208%2010%203%201-9-7-21-11-14m-43%207l-5%203c-2%203-11%208-16%209-3%201-5%202-7%206-3%205-6%206-9%203l-4-1h-2l-1-1-2-1c0-2-5-1-5%201-1%202-3%203-3%200h-2c-2%201-2%202-1%207%201%2012%203%2014%2018%2015a349%20349%200%200135%202c-4-1-4-1-3-3s3-2%207-2c5%200%206%200%207-2l4-3c21-5%2037-15%2024-14l-5-1%202-1c2%201%202-3%201-4-2-1-3%200-3%202%200%204-6%204-10%201l-2-2-1-1%203-1c2%200%202%200%201-1l-1-3v-4l-1-1c-1%201-1%201%200%200%201-4-14-7-19-3M90%2096a2988%202988%200%2000-3%2015v-4c1-1%201-1-1-1l-3-1h-1c-1%201%200%202%201%203l1%201h-6v1l1%201-2%201-3%201-4%201h-4l3%201%203%201%203%201c5%200%203%201-3%201l-5%201%204%201%202%202-2%201h-2l-1%201-2%202-2%201v1l2%203c0%202%203%205%204%205h1l-2%201-2-1-1-1v5c0%203%200%203-1%202-2-1-3%200-2%202l-1%202-3%203c0%203%200%203-1%201h-1l-1%202h-6c-4%201-4%201-4%206l1%204v3l3%201c4%200%204%200%204%202s0%202%202%202l2%202-4%201-4-2-1-2-1%202c1%202%201%202-4%201-7%200-6%200-5-4l2-3h-4c-4%200-6%200-8-2-5-4-6-4-3-1%204%205%200%204-8-2s-12-7-12-5H3l8%207c7%205%2011%209%207%208-2-1-5%201-5%203%200%201-5%204-8%204l1-2c0-3%203-6%204-5l1-1-3-1-6%201c-2%200-2%200-2%2011v10h4l3%201-3%201H1l-1%209c0%208%200%209%202%209l1-2c-1-1%200-1%202-1h8c1%203%208%204%208%203l6-5%201%201%201%201%202%202h2l2-1c0-1%200-2%202-2a728%20728%200%20008%201c0%203%200%203%203%203l4%201-3%201c-2-1-3%200-4%201v2l2%201-1%201v8c-2%201%202%202%209%201l7-1c7%204%207%204-4%204l-13%201v1l4%202%208%202c4%200%205%200%204%201s-1%201%201%201h2c1%201-4%202-11%202h-5l4%201c3%201%203%201%201%201l-3%201-3%201c-3%200-3%200-2%201h9l2-1h4l4%201h-8l4%201%203%202-12%201h-2c3%200%202%202%200%202l-6-2-2%201c1%201%200%201-1%201v1c1%202%2013%202%2013%200l5-1h4l-4%201-3%201%202%201c4%202%202%203-2%202-3-1-9-1-8%201%200%201%202%201-14%202l-13-1-5-1c-6-1-7-3-2-3l3%201c-1%201%200%201%202%201s2%200%201-1c-3-1%200-2%204-2%203%200%203%200%202-2h-2c-1%201-2%200-2-2-1-2-5-3-7-2-1%201%200%202%201%203%202%201%202%201-5%201l-8-1c-1-3-2%200-2%207v7h11l-5%201c-5%200-6%200-6%202l13%201%2012-1h-4c-3%200-4%200-3-1l3-1h3l-3-1-2-1h6c1%201%202%202%204%201%205%200%206-2%202-2-2%200-2%200-1-1l7-1%205%201-4%201-3%202h5c8-1%209-1%206-2s-1-1%205-1c4%200%207%200%206%201-8%201-8%201-4%203l2%201%201%201a171%20171%200%200048-1c9%200%2010%200%205-1l-12-1c-11%200-7-2%204-3%205%200%208%200%207%201-2%201-1%201%204%201%203%200%204%200%203-1-6%200-5-2%201-2l13-2%207-1-4-1h-5l-6%201-19-1H89l2-2c3-2%204-2%207-1h8l4-1c2-1-1-2-9-1-4%200-6%200-5-1%202-1%200-3-3-3l2-1c3-1%203-1%201-1h-3l2-1h6l3%201-3%201c-2%201-2%201%200%201l2-1%204-1c2%201%202%201-3%202l-6%202h6l7%201c1%201%201%201%201-1-1-2-1-2%204%200h7c1-1%201-1-1-1l-2-1h-5l-3-1%201-1c2%200%202%200%202-2v-3c1%200%201-1-1-1-1-1%201-1%205-1l6-1c0-1-4-2-5-1l-8%201c-4%200-5%200-4-1l2-1h3c1%200%202%200%201-1l-2-1h-3l-6%201c-3%200-3%200-1%201s2%201-2%201h-5l5%201%208%201c5%200%204%202-2%203-5%201-15%200-16-1l1-1c2-2%202-2%200-3-1-1-1-1%202-1s5-3%202-3c-3-1%2013-2%2017-1l3-1c0-3%200-4%204-3l3-1%204-1c4%200%204%200%201-1l-3-1-4-1-4-1c1-2-2-4-3-2-2%202-17%203-17%200h2l5%201%206-1c2%200%203%200%202-1-2%200%200-2%203-2%202%200%202%200%201-1v-1l1-1c-1-1%200-1%201-1l-1-1c-2-1-2-1%200-1h4c4%202%208%202%208%200l1-1%202-1v-3c1-3%201-3-1-3-2-1-1-1%201-1%203%200%204%200%203%202l3%201%202-1c-1-2%201-2%2011-2h12l3%204c3%205%204%208%203%208l-1%201-3%203-5%203c-2%202-2%202%202%202l5%201h-5c-4%200-5%200-3%201l2%201-2%201-5%202-3%201%205%202%203%201c-2%200-2%200-1%201s1%201-1%201l-4%202-2%201c-2%200-2%200%200%201s2%201-1%201c-6%200-2%201%204%202h7l-2%201c-2%200-4%202-1%202%201%201%201%201-1%201-4%200-5%202-2%202%202%201%201%201-2%202l-2%201c3%200%203%202-1%202-1%200-2%200-1%201l2%201%204%202%205%201c2%200%202%200%201%201l-1%201v1c-2%201-2%201%202%201h11c4%201-2%202-16%202l-9%201%204%201h-4l-4%201-1%201h14c15%200%2025-1%2019-3-2-1-2-1%201-1l5%201v2l-2%201a1964%201964%200%2000143-1l-1-2-2-2-2-3-1-2%201-1c3-1%203-3-1-4l-3-1%207%201h2l-2-2-2-1-1-1v-3c-1-1%201-1%203-1%204%200%204%200%202-1-3-2-3-3%202-3s5-1-1-1c-7%200-8-3-2-5h9c-1%201-1%201%201%201%202%201%202%201%200%201l-2%201%201%201h3c1%201%201%201-1%201s-2%200%200%201l3%204h-10a1000%201000%200%200111%203c5%201%2011%201%2010-1h-5c-3%200-3%200-2-1l3-2-1-2c-1-3-1-3%202-3%202-1%203-1%202-2l-2-1-2-2c-1-1-1-1%201-1s2%200%202-2c-1-2%200-3%201-5%202-2%202-2%201-3-2%200-1-3%201-5v-2l-2-3-1-4-2-5v-3h8c7%200%208%200%208%202%201%203%203%204%203%201s0-3%204-3l3-1h-2c-2%200-1%200%201-2%203-1%203-1%201-2l-2%201h-3c-1-1-2-2-2-9-1-13-1-14%201-14l2-1%2018-2h18v10l1%2010v-12l-1-12-20%201-20%201a360%20360%200%2001-2-30l-1%2015v15h-6c-7%200-9%202-3%202l5%201h-5l-4%201%206%201h7l1%205v11l-1%206h-4c-5%200-6-1-4-2%201-1-1-1-7-1-1%200-2-1-2-3s-2-4-3-2l-2-2c-1-3-1-2-1%204%200%202%200%202-1%200s-1-2-1%201l-3%2013h-4l-6-1-3%201v-23h-16c-17-1-45%200-45%201l6%201h5v4c0%204%200%205-2%204-4%200-6-1-6-3l-2-1c-1%200-2%200-1-1l-2-1-4-1-5-1-4-1c-1-1-9%200-9%201l2%201c2%200%201%201-2%201-5%201-8%202-10%204-3%202-6%203-6%201h-9c-3%200-4%200-4-2l-3-3c-2-1-2-1-2%202l-4%202c-2%200-2%200-1-1%202-1%201-1-5-1-4-1-5%200-3%201h-3l-11-3v-16l-8-1h-11c-2%201-2%207%200%2013%202%204%202%204-4%204-5%200-5%200-3-1%203-2%203-4%200-4s-5-2-5-5c1-1%200-2-1-2l-1-1-2-2c-2%200-4-2-3-4l-1-1-2%202-1%202c-2%200-2%200-1-2s1-4-2-3l-1-1%206-3c2-1-2-1-5-1-2%200-2%200%200-1l3-2h-4l-4%202-2%201-1-1-1-1c-1-1-2-2-1-3l2-1c2%201%201-1-2-5-2-4-2-4-8-4-4%200-6%200-5%201l2%202v7l1%204%201%202v1h-8l-2-2h-2l2-1c2-1%202-2%201-3v-3c-3%200-4-2-2-3v-2l-1-4-1-9v-9l1-2-1-1c-2%201-2%200-2-1%200-2%200-2%202-1%201%202%202%202%202%201v-1c-3%200%200-2%204-3l6-1-5%201c-5%200-5%200-5-2%201-1%201-1-1-1l-3%201v-11c0-7-1-9-1-6m217%2034a1047%201047%200%2001-2%2013l1%206h3c2%200%203%200%202-1v-5l-1-4v-2c2-1%202-3%201-3v-3c0-4-1-4-4-1m-13%203v5c1%202%201%202-1%202-2-1-2-1-2%201s0%202-1%200l-1-2c1-1%200-1-1-1h-3l1%205c0%207%201%207%203%204h2l3%201c3%200%203%200%203-4l1-5c2-3%201-5-1-5l-2-1h-1m-4%2017h-7c-9%201-9%202-9%2011%200%208%202%2012%204%208%200-3%202-4%208-3%201%200%202-1%204-7%202-7%202-5%200%203%200%203%200%203%202%203l2-1h3l2-1h1l2%201%203%201c1%203%204%201%206-6l2-7h-4l-19-2m-234%208v3h9l13%202%204-1c0-2-1-2-4-2-12%200-24-2-13-3h6c1%201%202%201%201-1l-8-1h-8v3m8%2010c-3%202%201%206%207%206l2%202v2h-1l6%201%204-1-3-1c-7%200-6-3%200-3%205%200%205%200%202-1-4%200-5-1-4-3%200-3-10-4-13-2m68%209l1%202c3%201-2%203-7%203-8%200-11%200-8%201%201%201%201%201-1%201s-3%200-2-2l-1-2h-1l-2-1-2%201c0%201%201%202%202%201l2%201c-1%202-19%202-23%200l-2%201v1l-1-1-11-1H61l-2-1-2%201-2%201v-1l1-1-3%201c-1%202-2%202-3%201H39l-1%201-1%201-1-1v-2l-1%202h-4v-1l1-1-3-1v2c-6%201-7%200-7-1l-1-1-1%202-1%201-2%201v1c0%201-2%200-2-2l-2-1-1-1h-2c-3%202-2%203%201%203%202%200%203%200%202%201l-1%204c-1%202-1%202%2038%202a52686%2052686%200%2001110%200c0-5-7-7-20-7-6%200-7-1-5-3v-2l1-2c0-1-3-2-4-1m161%208c0%204%200%204-2%204s-3%200-3-2%200-2-1-1v2h-2c-2-1-3-1-3%201l-2%201-3-1-2-2h-2c-1-1-1-1-1%201l-2%202c-3%200-3%200-3%204v3h10c10-1%2010-1%2010%201l1%202v1l-2-1c0-2-2-2-9-2-10%200-10%200-10%202%200%203%200%203%209%202a332%20332%200%200014%200l1%201c2%200%201-5%200-6-2%200-2-4-1-6s5-1%205%201l1%201c2%200%200-11-1-12-2-2-3-1-2%204m105%207l-1%203-2%202c-3%200-4-2-1-2l-6-1-10%201h-1l-2-2c-3%200-4%201-1%204%202%202%203%202%2012%202l10%201%201%207v6h-9l5%201%204%201c0%203%200%204%202%204l1-16c0-13%200-12-2-11\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/a0b32722ec3cedde7299e09507965df0/ca0a1/kr3gtct.webp 223w", "/static/a0b32722ec3cedde7299e09507965df0/75680/kr3gtct.webp 445w", "/static/a0b32722ec3cedde7299e09507965df0/002e6/kr3gtct.webp 520w"],
              "sizes": "(max-width: 520px) 100vw, 520px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/a0b32722ec3cedde7299e09507965df0/e92b6/kr3gtct.png 223w", "/static/a0b32722ec3cedde7299e09507965df0/e66bf/kr3gtct.png 445w", "/static/a0b32722ec3cedde7299e09507965df0/69902/kr3gtct.png 520w"],
              "sizes": "(max-width: 520px) 100vw, 520px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/a0b32722ec3cedde7299e09507965df0/69902/kr3gtct.png",
              "alt": "kr3gtct",
              "title": "kr3gtct",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`And that's how you can use ducks to solve TypeScript's biggest flaw – lack of type support at runtime.`}</p>
    <p>{`Hope this was useful ✌️`}</p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      